import { Z as THRESHOLD, U as POSTERIZE, $ as BLUR } from '../constants-tYr0tCl8.js';

const filterParamDefaults = {
  [BLUR]: 3,
  [POSTERIZE]: 4,
  [THRESHOLD]: 0.5,
};

export { filterParamDefaults };
